export const getPreviousMonth = (currentStartDate: Date, currentEndDate?: Date): [Date, Date] => {
  // Use end date if provided to determine the reference month, otherwise use start date
  const referenceDate = currentEndDate || currentStartDate;
  const startOfPrevMonth = new Date(referenceDate.getFullYear(), referenceDate.getMonth() - 1, 1);
  const endOfPrevMonth = new Date(startOfPrevMonth.getFullYear(), startOfPrevMonth.getMonth() + 1, 0);
  // console.log(`Month backward ${startOfPrevMonth} - ${endOfPrevMonth}`);
  return [startOfPrevMonth, endOfPrevMonth];
};
  
export const getNextMonth = (currentStartDate: Date, currentEndDate?: Date): [Date, Date] => {
  // Use end date if provided to determine the reference month, otherwise use start date
  const referenceDate = currentEndDate || currentStartDate;
  const startOfNextMonth = new Date(referenceDate.getFullYear(), referenceDate.getMonth() + 1, 1);
  const endOfNextMonth = new Date(startOfNextMonth.getFullYear(), startOfNextMonth.getMonth() + 1, 0);
  // console.log(`Month forward ${startOfNextMonth} - ${endOfNextMonth}`);
  return [startOfNextMonth, endOfNextMonth];
};